<template>
    <table>
        <tr class="th-totals">
            <th class="referencia"></th>
            <th class="operacao"></th>
            <th class="hora"></th>
            <th class="tempo"></th>
            <th class="discount">{{$t('module-budget.main-budget.parts.parts-totals.discount-label')}}</th>
            <th class="total">{{$t('module-budget.main-budget.parts.parts-totals.subtotal')}}</th>
        </tr>

        <tr class="tr__registers" ref="partsSubTotals">
            <td class="referencia"></td>
            <td class="operacao"></td>
            <td class="hora"></td>
            <td class="tempo"></td>
            <td class="discount">
                <span v-if="isPreview">{{ totalDiscount }}</span>
                <v-text-field
                    v-else
                    v-model="totalDiscount"
                    type="number"
                    @keypress="onlyNumberRule"
                    min="0"
                    max="100"
                    :aria-label="$t('module-budget.main-budget.parts.parts-totals.total-discount-label')"
                    outlined
                    dense
                    hide-details
                    class="input-number"
                    @input="commitToStore"
                    :rules="descMaxRule"
                    @change="ruleDescMax(totalDiscount)"
                    data-cy = "discount-total-parts"
                >
                </v-text-field>
            </td>
            <td class="total" data-cy="parts-net-subtotal">
                {{ computedTotalWithoutDiscount | currency }}
            </td>
        </tr>

        <tr class="tr__registers">
            <td colspan="6" class="lasts-line-of-totals">
                <p>{{$t('module-budget.main-budget.parts.parts-totals.total-liquid-label')}}</p>
                <p ref="partsNetSubTotalMO" data-cy="parts-net-total">
                    {{ computedTotalWithDiscount | currency }}
                </p>
            </td>
        </tr>
    </table>
</template>

<script>

export default {
    props: {
        isPreview: { type: Boolean },
        globalDiscount: { type: [Number, String], default: 0 },
        isIam: { type: Boolean, require: false}
    },
    data() {
        return {
            totalDiscount: this.globalDiscount,
            descMaxRule: [v => (v >= 0 && v <= 100) || this.$t('module-budget.main-budget.parts.parts-totals.rule-discount-desc')],
        };
    },
    computed: {
        computedTotalWithoutDiscount() {
          const totalInCents = this.$store.state.budget.b2b.budgetSummary.parts.values.reduce((acc, row) => {
            if (!isNaN(row.totalWithoutVAT)) {
              return acc + Math.round(row.totalWithoutVAT * 100);
            } else {
              return acc; // Não adiciona o valor inválido à soma
            }
          }, 0);
          return totalInCents / 100;
        },
        computedTotalWithDiscount() {
            return this.totalDiscount > 0
                ? this.computedTotalWithoutDiscount * (1 - this.totalDiscount / 100)
                : this.computedTotalWithoutDiscount;
        }
    },
    watch: {
        computedTotalWithDiscount(newValue, oldValue) {
            this.commitToStore();
        },
        computedTotalWithoutDiscount(newValue, oldValue) {
            this.commitToStore();
        }
    },
    methods: {
        commitToStore() {
            const partsTotals = {
                globalDiscount: this.totalDiscount,
                totalWithoutDiscount: this.$options.filters.currency(+this.computedTotalWithoutDiscount, true, false),
                totalWithDiscount: this.$options.filters.currency(+this.computedTotalWithDiscount, true, false)
            };

            this.$store.commit('budget/setPartTotalsToBudgetSummary', partsTotals);
            this.$store.commit('budget/setShoppingCartTotals', {isOp: false, totals: partsTotals });
        },
        ruleDescMax(value) {
            if (value > 100) {
                this.totalDiscount = 100;
                this.commitToStore();
            }else if(value < 0){
                this.totalDiscount = 0;
                this.commitToStore();
            }
        }
    },
    mounted() {
        this.commitToStore();
    }
};
</script>

<style lang="scss" scoped>
@import '../operations/table-style.scss';


.input-number{
    ::v-deep input{
        text-align: right;
    }
}
</style>
